export const RETURN_TYPES = {
  refund: "refund",
  exchange: "exchange",
  warrantyClaim: "warranty_claim",
  refundExchange: "refund_exchange",
  replacement: "replacement",
  replacementExchange: "replacement_exchange",
  replacementRefund: "replacement_refund",
  refundReplacementExchange: "refund_replacement_and_exchange",
};

export const REFUND_REQUEST_TYPES = new Set([
  RETURN_TYPES.refund,
  RETURN_TYPES.refundExchange,
  RETURN_TYPES.replacementRefund,
  RETURN_TYPES.refundReplacementExchange,
]);

export const EXCHANGE_FULFILLMENT_REQUEST_TYPES = new Set([
  RETURN_TYPES.exchange,
  RETURN_TYPES.refundExchange,
  RETURN_TYPES.replacement,
  RETURN_TYPES.replacementExchange,
  RETURN_TYPES.replacementRefund,
  RETURN_TYPES.refundReplacementExchange,
]);

export const EXCHANGE_ONLY_REQUEST_TYPES = new Set([
  RETURN_TYPES.exchange,
  RETURN_TYPES.replacement,
  RETURN_TYPES.replacementExchange,
]);

export function deriveRequestReturnType(lineItemTypes = [], fallback = RETURN_TYPES.exchange) {
  const types = new Set(lineItemTypes.filter(Boolean));
  const hasRefund = types.has(RETURN_TYPES.refund);
  const hasExchange = types.has(RETURN_TYPES.exchange);
  const hasReplacement = types.has(RETURN_TYPES.replacement);
  const hasWarranty = types.has(RETURN_TYPES.warrantyClaim);

  if (hasWarranty) {
    return RETURN_TYPES.warrantyClaim;
  }
  if (hasRefund && hasExchange && hasReplacement) {
    return RETURN_TYPES.refundReplacementExchange;
  }
  if (hasReplacement && hasExchange) {
    return RETURN_TYPES.replacementExchange;
  }
  if (hasReplacement && hasRefund) {
    return RETURN_TYPES.replacementRefund;
  }
  if (hasRefund && hasExchange) {
    return RETURN_TYPES.refundExchange;
  }
  if (hasReplacement) {
    return RETURN_TYPES.replacement;
  }
  if (hasExchange) {
    return RETURN_TYPES.exchange;
  }
  if (hasRefund) {
    return RETURN_TYPES.refund;
  }

  return fallback;
}

export const hasRefundRequestType = (returnType) =>
  REFUND_REQUEST_TYPES.has(returnType);

export const hasExchangeFulfillmentRequestType = (returnType) =>
  EXCHANGE_FULFILLMENT_REQUEST_TYPES.has(returnType);

export const isExchangeOnlyRequestType = (returnType) =>
  EXCHANGE_ONLY_REQUEST_TYPES.has(returnType);
